import AssetSubtypeList from "../components/asset-subtype/AssetSubtypeCrud";

const AssetSubtypeCrudPage = () => {
  return (
    <>
      <AssetSubtypeList />
    </>
  );
};

export default AssetSubtypeCrudPage;
